export default "__VITE_ASSET__DXkz7jlB__"